import React, { useState } from 'react';
import axios from 'axios';

function ContactForm() {
  const [formData, setFormData] = useState({ name: '', email: '' });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post('https://skyblue-wren-756847.hostingersite.com/api/save-form.php', formData);
      alert('Form submitted successfully!');
      setFormData({ name: '', email: '' });
    } catch (error) {
      alert('Error submitting form.');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <label>Name:</label>
      <input type="text" name="name" value={formData.name} onChange={handleChange} required />

      <label>Email:</label>
      <input type="email" name="email" value={formData.email} onChange={handleChange} required />

      <button type="submit">Submit</button><br></br>
      <br></br>
      <a href="/home-5">Back To Home</a>
    </form>
  );
}

export default ContactForm;
